"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AllUserFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AllUserFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43 3.407a2.25 2.25 0 1 0-1.225.98c.33-.41.748-.747 1.225-.98ZM10.793 4.387a3.594 3.594 0 0 0-1.223-.98 2.25 2.25 0 1 1 1.223.979ZM5.493 5.843a2.625 2.625 0 1 0 5.013 1.563 2.625 2.625 0 0 0-5.013-1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.519 5.786H4.5c-2.7 0-4.5 1.209-4.5 2.7a1.8 1.8 0 0 0 1.8 1.8h3.104a8.385 8.385 0 0 1 1.635-.392 3.58 3.58 0 0 1-2.02-4.108ZM9.46 9.894a8.384 8.384 0 0 1 1.635.392H14.2a1.8 1.8 0 0 0 1.8-1.8c0-1.491-1.8-2.7-4.5-2.7h-.02a3.58 3.58 0 0 1-2.02 4.108ZM2.75 13.9c0-1.74 2.1-3.15 5.25-3.15s5.25 1.41 5.25 3.15a2.1 2.1 0 0 1-2.1 2.1h-6.3a2.1 2.1 0 0 1-2.1-2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AllUserFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AllUserFill;
exports["default"] = _default;